import './WeekDaysHeader.css';
export default {
    "weekDaysHeader": "WeekDaysHeader_weekDaysHeader__19v4h",
    "weekDay": "WeekDaysHeader_weekDay__19v4h"
};
